export default "__VITE_ASSET__b107e69a__"